import Spin from '../assets/spinner.gif'

function Spinner() {
  return (
    <div className="spinner">
      <img src={Spin} alt="spinner" width={60} />
    </div>
  )
}

export default Spinner
